<div class="p-l-header header-container h-header header-row d-flex flex-row justify-content-between align-items-center"
    [ngClass]="[(locationUrl == ('/wiz/smartthermo') || locationUrl == ('/wiz/softsecurity') || locationUrl == ('/summary-view/report'))  ? 'header-background' : '',
               (homeHeader && locationUrl != ('/open')) ? 'header-home-mobile' : '']">
  <div class="">
    <img src="../../assets/img/logo.png" alt="BTicino Logo" (click)="onLogoClick()">
  </div>
  <div class="privacy-textlink">
    <a href="javascript:Didomi.preferences.show()" class="privacy-link">Privacy</a>
  </div>
</div>
